<!--LinkItem: 链接组 2021/03/25 17:08:58 Sunanguang-->

<template>
  <div class="its-link-item" :class="{'its-link-disable': item.noLinks}">
    <p v-if="item.url"><a :href="item.url" target="_blank" title="查看详情">{{item.title}}</a></p>
    <p v-else>{{item.title}}</p>
    <ul v-if="item.links.length > 0" class="its-link-list">
      <li v-for="(link, i) in item.links" :key="'link-'+i" class="its-link-i" @click="clickLink(link)" v-html="link.name"></li>
    </ul>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'LinkItem',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    clickLink: function (link) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      if (link.url.indexOf('http') === -1) {
        if (link.id) {
          this.$root.activeNavigation(link.id)
        }
        if (link.url) {
          this.$router.push(link.url)
        }
      } else {
        window.open(link.url, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.its-link-item {
  text-align: left;
}
.its-link-item p {
  font-size: 20px;
  color: black;
}

.its-link-item .its-link-list {
  margin-top: 11px;
}

.its-link-item .its-link-list .its-link-i {
  color: rgba(51, 51, 51, 0.6);
  font-size: 16px;
  margin-bottom: 15px;
  cursor: pointer;
}

.its-link-item > p a:hover,
.its-link-item .its-link-list .its-link-i:hover {
  color: #50a4f8;
}

.its-link-disable .its-link-i {
  cursor: text !important;
}

.its-link-disable .its-link-i span:hover {
  color: rgba(51, 51, 51, 0.6) !important;
}

.its-link-disable .its-link-i:hover {
  color: black !important;
}
</style>